export default __webpack_public_path__ + "static/media/empty_activities.425cf8c2.svg";